import { render, staticRenderFns } from "./gasClamp_steelboxPower.vue?vue&type=template&id=c867e3f4&scoped=true"
import script from "./gasClamp_steelboxPower.vue?vue&type=script&lang=js"
export * from "./gasClamp_steelboxPower.vue?vue&type=script&lang=js"
import style0 from "./gasClamp_steelboxPower.vue?vue&type=style&index=0&id=c867e3f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c867e3f4",
  null
  
)

export default component.exports